import { Link } from "@digdir/designsystemet-react";
import { ExternalLinkIcon } from "@navikt/aksel-icons";
import { Link as InternalLink } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { cn } from "@/utils";

export const Footer = ({ className }: { className?: string }) => {
  const { t } = useTranslation();

  return (
    <footer
      className={cn(
        "flex flex-col xl:flex-row justify-end items-center w-full h-footer-mobile xl:h-footer py-4 px-10 bg-balder-background-tinted border-t border-b border-balder-border-subtle ",
        className,
      )}
    >
      <div className="flex flex-col xl:flex-row items-center xl:items-baseline gap-6">
        <Link data-size={"sm"} asChild>
          <InternalLink to="/kundestøtte" className="text-balder-text-default">
            {t("eksterneLenker.kundestotte.label")}
          </InternalLink>
        </Link>
        <Link
          target="_blank"
          rel="noreferrer"
          href={t("eksterneLenker.cookies.url")}
          data-size={"sm"}
        >
          {t("eksterneLenker.cookies.label")}
          <ExternalLinkIcon fontSize={"1.5rem"} className="pl-1" />
        </Link>
        <Link
          target="_blank"
          rel="noreferrer"
          href={t("eksterneLenker.tilgjengelighetserklæring.url")}
          data-size={"sm"}
        >
          {t("eksterneLenker.tilgjengelighetserklæring.label")}
          <ExternalLinkIcon fontSize={"1.5rem"} className="pl-1" />
        </Link>
      </div>
    </footer>
  );
};
